declare module 'vue/types/vue' {
  interface Vue {
    $s: {
      loading: {
        show: Function;
        hide: Function;
      };
      notify: {
        success: Function;
        error: Function;
        warning: Function;
      };
    };
    $debug: (...args) => void;
  }
}

export const helpers = (store, quasar) => {
  function callNotification(message: string, additionalParameters: {}) {
    const quasarNotifyConfig = {
      ...{
        message,
        color: 'green-6',
        position: 'top',
        textColor: 'white',
        timeout: 2500,
        actions: [{ icon: 'close', color: 'white' }],
      },
      ...additionalParameters,
    };
    quasar.notify(quasarNotifyConfig);
  }
  return {
    loading: {
      show() {
        store.dispatch('loading/setRouteLoading', true);
      },
      hide() {
        setTimeout(() => {
          store.dispatch('loading/setRouteLoading', false);
        }, 50);
      },
    } as any,
    notify: {
      success(message: string, additionalParameters: {}) {
        callNotification(message, { color: 'green-6', ...additionalParameters });
      },
      warning(message: string, additionalParameters: {}) {
        callNotification(message, { color: 'orange-6', ...additionalParameters });
      },
      error(message: string, additionalParameters: {}) {
        callNotification(message, { color: 'red-8', ...additionalParameters });
      },
    } as any,
  };
};

export const debug = function debug(this: Vue, ...args) {
  // eslint-disable-next-line no-console
  console.debug(`[${this.$options.name}] -`, ...args);
};
